import { PlayStatus } from '../../../learnware/LearnwareEnums';
export class IntentInfo {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get intent() {
        return this.parent;
    }
    get mediaPlayer() {
        return this.intent.mediaPlayer;
    }
    get durationInSeconds() {
        if (this.intent.intentSettings.sequenceEndPosition && this.intent.intentSettings.sequenceStartPosition) {
            return this.intent.intentSettings.sequenceEndPosition - this.intent.intentSettings.sequenceStartPosition;
        }
        return this.intent.medFile.durationInSeconds;
    }
    get remainingSeconds() {
        if ([PlayStatus.Aborted, PlayStatus.Error, PlayStatus.Paused, PlayStatus.Ended].includes(this.intent.playStatus))
            return 0;
        if (this.isIntentCompleted)
            return 0;
        return this.durationInSeconds - this.intent.progressInSeconds;
    }
    get isPlaying() {
        return this.mediaPlayer.playerIntents.playingIntents.includes(this.intent);
    }
    get progressPercent() {
        return 100 * (this.intent.progressInSeconds / this.durationInSeconds);
    }
    get isIntentCompleted() {
        return !!this.intent.endDate;
    }
    get secondsSinceComplete() {
        if (!this.intent.endDate)
            return 99999;
        return (this.mediaPlayer.app.appClock.clock_250.tickingTime - this.intent.endDate.getTime()) / 1000;
    }
    get channel() {
        return this.mediaPlayer.playerChannels.getChannel(this.intent.intentSettings.playbackChannel);
    }
}
